<template>
  <div class="yzd-page">
    <div class="table-box">
      <div class="table" v-for="(val, key, i) in oddsList" :key="i">
        <table cellspacing="0" cellpadding="0">
          <thead>
            <th class="bold" colspan="3">第{{ i | numberFormate }}球</th>
          </thead>
          <tbody>
            <tr
              class="ball-td"
              :class="{ bc_ball: ball.isChecked }"
              style="cursor: pointer"
              @click="choiceBall(ball)"
              v-for="(ball, ballIndex) in oddsList[key].list"
              :key="ballIndex"
            >
              <td class="bc">
                <div :class="`ball ball${ballIndex}`"></div>
              </td>
              <td
                class="bold"
                :class="ball.isChecked ? 'text-primary-bg' : 'bet-text-yzd'"
              >
                {{ isClose == 0 ? ball.peilv : "--" }}
              </td>
              <td style="position: relative">
                <input
                  @click.stop
                  @focus="choiceBall(ball, true)"
                  @keyup.enter="confirmBet()"
                  oninput="value=value.replace(/[^\d]/, '')"
                  class="default_border"
                  :disabled="isClose == 1"
                  :readonly="isClose == 1"
                  style="
                    width: 50px;
                    height: 18px;
                    line-height: 13px;
                    font-size: 12px;
                    color: var(--new-text);
                    border-radius: 4px;
                    vertical-align: text-top;
                    text-align: center;
                  "
                  type="text"
                  v-model="ball.money"
                />
                <!-- <span
                  v-else
                  style="
                    display: inline-block;
                    width: 48px;
                    height: 18px;
                    line-height: 18px;
                    font-size: 12px;
                    border: 1px solid #aaa;
                    color: #aaa;
                    border-radius: 2px;
                  "
                >
                  封盘
                </span> -->
                <!-- <i
                  v-show="ball.isChecked"
                  style="
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: 2px;
                    fotn-size: 16px;
                    color: rgb(7, 132, 11);
                  "
                  class="el-icon-circle-check"
                ></i> -->
              </td>
            </tr>
          </tbody>
        </table>
        <div class="table-bottom">
          <span
            :class="{ active: oddsList[key].isBig }"
            @click="choiceBtn(key, 'big')"
            >大</span
          >
          <span
            :class="{ active: oddsList[key].isSmall }"
            @click="choiceBtn(key, 'small')"
            >小</span
          >
          <span
            :class="{ active: oddsList[key].isSingle }"
            @click="choiceBtn(key, 'single')"
            >单</span
          >
          <span
            :class="{ active: oddsList[key].isDouble }"
            @click="choiceBtn(key, 'double')"
            >双</span
          >
        </div>
      </div>
    </div>

    <div class="bottom—tool-yzd">
      <!-- <div class="title">下注金额</div> -->
      <div class="content-yzd">
        <div class="money-tool-yzd">
          <div style="position: relative" v-clickoutside="handleClickoutside">
            <input
              class="btn primary"
              type="button"
              value="快选金额"
              @click="handleShowPreMoney()"
            />
            <ul
              v-show="showPreMoney"
              style="
                position: absolute;
                bottom: 25px;
                left: 0;
                right: 0;
                background: #fff;
                border: 1px solid #bad4e8;
                border-radius: 5px;
                box-shadow: rgb(204, 204, 204) 2px 2px 5px;
              "
            >
              <li
                style="padding: 5px 10px"
                v-for="(item, index) in preMoney"
                :key="index"
              >
                <input
                  style="
                    padding: 5px;
                    width: 50px;
                    height: 25px;
                    border-radius: 2px;
                  "
                  type="text"
                  v-model="preMoney[index]"
                />
              </li>
              <li style="padding: 5px 10px">
                <input
                  class="btn primary"
                  type="button"
                  value="确认"
                  @click="surePreMoney()"
                />
              </li>
            </ul>
          </div>
          <div style="margin-left: 40px; margin-right: 20px">
            <span
              v-for="(item, index) in showPreMoneyList"
              :key="index"
              @click="money = item"
              class="choice-money"
            >
              {{ item }}
            </span>
          </div>
        </div>
        <!-- <el-checkbox />
        <span style="margin-right: 7px">预设</span> -->
        <span class="bold active-text" style="margin-right: 8px">下注金额</span>
        <input
          class="input-money input"
          type="text"
          placeholder="输入金额"
          @keyup.enter="confirmBet()"
          oninput="value=value.replace(/[^\d | ^.]/g,'').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')"
          v-model="money"
        />
        <div class="btn-group">
          <input
            class="btn primary"
            type="button"
            value="确定"
            @click="confirmBet()"
          />
          <input
            class="btn info"
            type="button"
            value="重置 "
            @click="reset()"
          />
        </div>
      </div>
    </div>

    <div class="confirm-bet-wrapper" v-show="showComfirmBet">
      <div
        class="confirm-bet"
        tabindex="0"
        ref="confirmBet"
        @keyup.enter.capture="bet()"
      >
        <h1 class="title">
          确认下单<i class="el-icon-close" @click="showComfirmBet = false"></i>
        </h1>
        <div class="content">
          <table cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th>注单明细</th>
                <th>赔率</th>
                <th>下注金额</th>
                <th>操作</th>
                <th>打印</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in betList" :key="index">
                <td style="width: 120px">
                  {{ item.number | betNumberFormate }}
                </td>
                <td style="width: 80px">{{ item.peilv }}</td>
                <td style="width: 120px">
                  <input
                    class="money"
                    type="text"
                    v-model="betList[index].money"
                  />
                </td>
                <td style="width: 80px">
                  <div class="del-bet" @click="delBetList(index)">
                    <i class="el-icon-close"></i>
                  </div>
                </td>
                <td style="width: 80px">
                  <el-checkbox v-model="item.printChecked" />
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <div
                    style="
                      color: var(--new-text-info);
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <div style="width: 120px; text-align: center">
                      总注数：<span>{{ betList.length }}</span
                      >笔
                    </div>
                    <div style="width: 160px; text-align: center">
                      合计金额：{{ sum(betList, "money") }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="btn-group">
          <input
            style="width: 100px"
            class="btn info"
            type="button"
            value="取消"
            @click="showComfirmBet = false"
          />
          <input
            style="width: 100px"
            class="btn primary"
            type="button"
            value="确认"
            @click="bet()"
          />
        </div>
        <div
          class="tips"
          style="
            margin: 17px 0 20px;
            text-align: center;
            font-size: 12px;
            color: var(--new-text-info);
          "
        >
          赔率变化，按最新赔率投注，不提示赔率变
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clickoutside from "element-ui/src/utils/clickoutside";

export default {
  data() {
    return {
      playcode: "D1W",
      showComfirmBet: false,
      showPreMoney: false,
      // presupposition: true,
      oddsList: {
        ball1: {
          isBig: false,
          isSmall: false,
          isSingle: false,
          isDouble: false,
          list: [],
        },
        ball2: {
          isBig: false,
          isSmall: false,
          isSingle: false,
          isDouble: false,
          list: [],
        },
        ball3: {
          isBig: false,
          isSmall: false,
          isSingle: false,
          isDouble: false,
          list: [],
        },
        ball4: {
          isBig: false,
          isSmall: false,
          isSingle: false,
          isDouble: false,
          list: [],
        },
        ball5: {
          isBig: false,
          isSmall: false,
          isSingle: false,
          isDouble: false,
          list: [],
        },
      },
      money: "",
      showPreMoneyList: ["50", "100", "200", "500", "1000"],
      preMoney: ["50", "100", "200", "500", "1000"],
      betList: [],
    };
  },
  mounted() {
    this.initData();
  },
  directives: {
    Clickoutside,
  },
  props: ["initFinished", "isClose"],
  watch: {
    isClose(newVal) {
      if (newVal == 0) {
        this.getBetList();
      } else {
        Object.values(this.oddsList).forEach((item) => {
          item.list.forEach((i) => (i.money = "封盘"));
        });
      }
    },
    showPreMoney(newVal) {
      if (newVal) {
        this.preMoney = JSON.parse(JSON.stringify(this.showPreMoneyList));
      }
    },
    initFinished() {
      this.getBetList();
    },
    money(newVal) {
      if (newVal !== "") {
        this.setCheckedMoney();
      }
    },
    //第一球
    "oddsList.ball1.isBig": function (newVal) {
      this.checkedByChoiceBtn("ball1");
    },
    "oddsList.ball1.isSmall": function (newVal) {
      this.checkedByChoiceBtn("ball1");
    },
    "oddsList.ball1.isSingle": function (newVal) {
      this.checkedByChoiceBtn("ball1");
    },
    "oddsList.ball1.isDouble": function (newVal) {
      this.checkedByChoiceBtn("ball1");
    },
    //第二球
    "oddsList.ball2.isBig": function (newVal) {
      this.checkedByChoiceBtn("ball2");
    },
    "oddsList.ball2.isSmall": function (newVal) {
      this.checkedByChoiceBtn("ball2");
    },
    "oddsList.ball2.isSingle": function (newVal) {
      this.checkedByChoiceBtn("ball2");
    },
    "oddsList.ball2.isDouble": function (newVal) {
      this.checkedByChoiceBtn("ball2");
    },
    //第三球
    "oddsList.ball3.isBig": function (newVal) {
      this.checkedByChoiceBtn("ball3");
    },
    "oddsList.ball3.isSmall": function (newVal) {
      this.checkedByChoiceBtn("ball3");
    },
    "oddsList.ball3.isSingle": function (newVal) {
      this.checkedByChoiceBtn("ball3");
    },
    "oddsList.ball3.isDouble": function (newVal) {
      this.checkedByChoiceBtn("ball3");
    },
    //第四球
    "oddsList.ball4.isBig": function (newVal) {
      this.checkedByChoiceBtn("ball4");
    },
    "oddsList.ball4.isSmall": function (newVal) {
      this.checkedByChoiceBtn("ball4");
    },
    "oddsList.ball4.isSingle": function (newVal) {
      this.checkedByChoiceBtn("ball4");
    },
    "oddsList.ball4.isDouble": function (newVal) {
      this.checkedByChoiceBtn("ball4");
    },
    //第五球
    "oddsList.ball5.isBig": function (newVal) {
      this.checkedByChoiceBtn("ball5");
    },
    "oddsList.ball5.isSmall": function (newVal) {
      this.checkedByChoiceBtn("ball5");
    },
    "oddsList.ball5.isSingle": function (newVal) {
      this.checkedByChoiceBtn("ball5");
    },
    "oddsList.ball5.isDouble": function (newVal) {
      this.checkedByChoiceBtn("ball5");
    },
  },
  filters: {
    numberFormate(value) {
      let result = "";
      value++;
      if (value == 1) {
        result = "一";
      } else if (value == 2) {
        result = "二";
      } else if (value == 3) {
        result = "三";
      } else if (value == 4) {
        result = "四";
      } else if (value == 5) {
        result = "五";
      }
      return result;
    },
    betNumberFormate(value) {
      let ballSort = "一";
      let ballNum = 0;
      let reg1 = /[0-9]XXXX/i;
      let reg2 = /X[0-9]XXX/i;
      let reg3 = /XX[0-9]XX/i;
      let reg4 = /XXX[0-9]X/i;
      let reg5 = /XXXX[0-9]/i;
      if (reg1.test(value)) {
        ballSort = "一";
        ballNum = value.substr(0, 1);
      } else if (reg2.test(value)) {
        ballSort = "二";
        ballNum = value.substr(1, 1);
      } else if (reg3.test(value)) {
        ballSort = "三";
        ballNum = value.substr(2, 1);
      } else if (reg4.test(value)) {
        ballSort = "四";
        ballNum = value.substr(3, 1);
      } else if (reg5.test(value)) {
        ballSort = "五";
        ballNum = value.substr(4, 1);
      }
      return `第${ballSort}球【${ballNum}】`;
    },
  },
  methods: {
    initData() {
      this.getBetList();
    },
    handleClickoutside() {
      this.showPreMoney = false;
    },
    handleShowPreMoney() {
      this.showPreMoney = !this.showPreMoney;
    },
    async getBetList() {
      if (this.initFinished) {
        let data = {
          access_token: this.$store.state.userInfo.access_token,
          uid: this.$store.state.userInfo.uid,
          code: this.$store.state.gameInfo[0].code,
          playcode: this.playcode,
        };
        let result = await this.$http.postAxiosMethod("/user/odds", data);
        if (result.data && result.code == 0) {
          this.oddsList.ball1.list = result.data.filter((item, index) => {
            let reg = /[0-9]XXXX/i;
            item.isChecked = false;
            item.money = "";
            return reg.test(item.number);
          });
          this.oddsList.ball1.list.sort((a, b) => {
            let num1 = a.number.substr(0, 1) * 1;
            let num2 = b.number.substr(0, 1) * 1;
            return num1 - num2;
          });
          this.oddsList.ball2.list = result.data.filter((item, index) => {
            let reg = /X[0-9]XXX/i;
            item.isChecked = false;
            item.money = "";
            return reg.test(item.number);
          });
          this.oddsList.ball2.list.sort((a, b) => {
            let num1 = a.number.substr(1, 1) * 1;
            let num2 = b.number.substr(1, 1) * 1;
            return num1 - num2;
          });
          this.oddsList.ball3.list = result.data.filter((item, index) => {
            let reg = /XX[0-9]XX/i;
            item.isChecked = false;
            item.money = "";
            return reg.test(item.number);
          });
          this.oddsList.ball3.list.sort((a, b) => {
            let num1 = a.number.substr(2, 1) * 1;
            let num2 = b.number.substr(2, 1) * 1;
            return num1 - num2;
          });
          this.oddsList.ball4.list = result.data.filter((item, index) => {
            let reg = /XXX[0-9]X/i;
            item.isChecked = false;
            item.money = "";
            return reg.test(item.number);
          });
          this.oddsList.ball4.list.sort((a, b) => {
            let num1 = a.number.substr(3, 1) * 1;
            let num2 = b.number.substr(3, 1) * 1;
            return num1 - num2;
          });
          this.oddsList.ball5.list = result.data.filter((item, index) => {
            let reg = /XXXX[0-9]/i;
            item.isChecked = false;
            item.money = "";
            return reg.test(item.number);
          });
          this.oddsList.ball5.list.sort((a, b) => {
            let num1 = a.number.substr(4, 1) * 1;
            let num2 = b.number.substr(4, 1) * 1;
            return num1 - num2;
          });
          this.refreshOdds();
        } else {
          document.activeElement.blur();
          this.$alert(result.msg, "提示");
        }
      }
    },
    choiceBall(ball, flag) {
      ball.isChecked = flag || !ball.isChecked;
      if (this.money) {
        ball.money = this.money;
      }
      this.oddsList = JSON.parse(JSON.stringify(this.oddsList));
    },
    choiceBtn(key, type) {
      if (type == "big") {
        this.oddsList[key].isBig = !this.oddsList[key].isBig;
      } else if (type == "small") {
        this.oddsList[key].isSmall = !this.oddsList[key].isSmall;
      } else if (type == "single") {
        this.oddsList[key].isSingle = !this.oddsList[key].isSingle;
      } else if (type == "double") {
        this.oddsList[key].isDouble = !this.oddsList[key].isDouble;
      }
      this.refreshOdds();
    },
    checkedByChoiceBtn(ball) {
      let isBig = this.oddsList[ball].isBig;
      let isSmall = this.oddsList[ball].isSmall;
      let isSingle = this.oddsList[ball].isSingle;
      let isDouble = this.oddsList[ball].isDouble;
      // 先取消勾选，再勾选
      if (!isBig) {
        this.oddsList[ball].list.forEach((item, index) => {
          if (index >= 5) {
            item.isChecked = false;
            item.money = "";
          }
        });
      }
      if (!isSmall) {
        this.oddsList[ball].list.forEach((item, index) => {
          if (index < 5) {
            item.isChecked = false;
            item.money = "";
          }
        });
      }
      if (!isSingle) {
        this.oddsList[ball].list.forEach((item, index) => {
          if (index % 2 !== 0) {
            item.isChecked = false;
            item.money = "";
          }
        });
      }
      if (!isDouble) {
        this.oddsList[ball].list.forEach((item, index) => {
          if (index % 2 === 0) {
            item.isChecked = false;
            item.money = "";
          }
        });
      }
      if (isBig) {
        this.oddsList[ball].list.forEach((item, index) => {
          if (index >= 5) {
            item.isChecked = true;
            if (this.money) {
              item.money = this.money;
            }
          }
        });
      }
      if (isSmall) {
        this.oddsList[ball].list.forEach((item, index) => {
          if (index < 5) {
            item.isChecked = true;
            if (this.money) {
              item.money = this.money;
            }
          }
        });
      }
      if (isSingle) {
        this.oddsList[ball].list.forEach((item, index) => {
          if (index % 2 !== 0) {
            item.isChecked = true;
            if (this.money) {
              item.money = this.money;
            }
          }
        });
      }
      if (isDouble) {
        this.oddsList[ball].list.forEach((item, index) => {
          if (index % 2 === 0) {
            item.isChecked = true;
            if (this.money) {
              item.money = this.money;
            }
          }
        });
      }
      this.refreshOdds();
    },
    setCheckedMoney() {
      for (let key in this.oddsList) {
        for (let i of this.oddsList[key].list) {
          if (i.isChecked) {
            i.money = this.money;
          }
        }
      }
      this.refreshOdds();
    },
    surePreMoney() {
      this.showPreMoneyList = JSON.parse(JSON.stringify(this.preMoney));
      this.showPreMoney = false;
    },
    async bet() {
      if (this.isClose == 0) {
        let betArr = [];
        let bet_str = "";
        this.betList.forEach((item) => {
          betArr.push(`${item.number}:${item.money}`);
        });
        bet_str = betArr.join(",");
        let data = {
          access_token: this.$store.state.userInfo.access_token,
          uid: this.$store.state.userInfo.uid,
          game_code: this.$store.state.gameInfo[0].code,
          key: new Date().getTime(),
          play_type: "zhixuan",
          total_money: this.sum(this.betList, "money"),
          bet_num: this.betList.length,
          bet_str,
          bet_log: "游戏日志",
          bet_qihao: this.$store.state.gameInfo[0].nextQihao,
        };
        let result = await this.$http.postAxiosMethod("/user/bet2", data);
        if (result.code == 0) {
          this.$message({
            iconClass: "fa fa-check-circle",
            customClass: "bet_message",
            type: "success",
            duration: 3000,
            message: "下注成功！",
          });
          this.showComfirmBet = false;
          this.reset();
          setTimeout(() => {
            this.$BUS.$emit("bet");
          }, 500);
        }
      } else {
        document.activeElement.blur();
        this.$alert("已封盘", "提示");
      }
    },
    sum(list, key) {
      let sum = 0;
      for (let i of list) {
        sum += i[key] * 1;
      }
      return sum;
    },
    delBetList(index) {
      this.betList.splice(index, 1);
      if (this.betList.length === 0) {
        this.showComfirmBet = false;
      }
    },
    reset() {
      for (let key in this.oddsList) {
        this.oddsList[key].isBig = false;
        this.oddsList[key].isSmall = false;
        this.oddsList[key].isSingle = false;
        this.oddsList[key].isDouble = false;
        for (let i of this.oddsList[key].list) {
          i.isChecked = false;
          i.money = "";
        }
      }
      this.money = "";
      this.refreshOdds();
    },
    confirmBet() {
      let betList = [];
      let betNumFlag = false;
      let betMoneyFlag = false;
      for (let key in this.oddsList) {
        betList = betList.concat(
          this.oddsList[key].list.filter((item) => {
            if (item.isChecked) {
              betNumFlag = true;
            }
            if (item.money != "") {
              betMoneyFlag = true;
            }
            return item.isChecked && item.money != "";
          })
        );
      }
      if (!betNumFlag) {
        document.activeElement.blur();
        this.$alert("请选择下注号码", "提示");
        return;
      }
      if (!betMoneyFlag) {
        document.activeElement.blur();
        this.$alert("请输入下注金额", "提示");
        return;
      }
      this.betList = betList.map((i) => ({
        ...i,
        printChecked: false,
      }));
      if (betList.length > 0) {
        this.showComfirmBet = true;
        this.$nextTick(function () {
          this.$refs.confirmBet.focus();
        });
      }
    },
    refreshOdds() {
      this.oddsList = JSON.parse(JSON.stringify(this.oddsList));
    },
  },
};
</script>

<style lang="scss" scoped>
.yzd-page {
  width: 835px;
  background: var(--new-bg-white);
  input[type="text"] {
    border: 1px solid var(--new-border);
  }
  .table-box {
    display: flex;
    // justify-content: space-between;
    // align-items: center;
    .table {
      width: 167px;
      font-size: 14px;
      overflow: hidden;
      > table {
        width: 167px;
        // border: 1px solid var(--new-border);
        thead {
          th {
            font-size: 13px;
            height: 30px;
            line-height: 30px;
            border-right: 1px solid var(--new-border);
            border-bottom: 1px solid var(--new-border);
            color: var(--new-text-table-header-main);
            background: var(--new-bg-table-header-main) !important;
          }
        }
        tbody {
          tr {
            td {
              font-size: 13px;
              line-height: 30px;
              text-align: center;
              border-right: 1px solid var(--new-border);
              div {
                margin: auto;
              }
              &:nth-child(1) {
                width: 40px;
                background: var(--new-bg-table-header-main);
              }
              &:nth-child(2) {
                width: 40px;
              }
            }
            // &:not(:last-child) {
            & {
              td {
                border-bottom: 1px solid var(--new-border);
              }
            }
          }
        }
      }
      &:first-child {
        > table {
          thead {
            th {
              border-left: 1px solid var(--new-border);
            }
          }
          tbody {
            tr td:first-child {
              border-left: 1px solid var(--new-border);
            }
          }
        }
        .table-bottom {
          border-left: 1px solid var(--primary-table-border-color);
        }
      }
      .table-bottom {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 167px;
        height: 45px;
        border-right: 1px solid var(--primary-table-border-color);
        border-bottom: 1px solid var(--primary-table-border-color);
        border-top: none;
        & > span {
          margin: 0 10px;
          display: inline-block;
          width: 25px;
          height: 25px;
          text-align: center;
          line-height: 25px;
          font-size: 12px;
          font-weight: bold;
          cursor: pointer;
          background: var(--new-bg-table-header-main);
          border-radius: 4px;
          // &:hover {
          //   color: #c7e6ff;
          // }
          &.active,
          &:hover {
            color: #fff;
            background: var(--new-bg-table-active);
          }
          &:not(:nth-child(1)) {
            border-left: none;
          }
        }
      }
    }
  }

  .ball-td {
    &:hover {
      td {
        &:not(:nth-child(1)) {
          background-color: var(--new-bg-table-hover) !important;
        }
      }
    }
    &.bc_ball {
      td {
        &:not(:nth-child(1)) {
          background-color: var(--new-bg-table-active) !important;
        }
      }
    }
  }

  .other-table {
    transform: translateY(-30px);
    width: 160px;
    overflow: hidden;
    .title {
      text-align: center;
      line-height: 30px;
      color: #fff;
      font-weight: bold;
      background: var(--primary-table-header-color);
    }
    .content {
      font-size: 13px;
      background: #fff;
      border: 1px solid var(--new-border);
      .tr {
        padding-left: 10px;
        line-height: 30px;
        &:not(:last-child) {
          border-bottom: 1px solid var(--new-border);
        }
      }
    }
    &.one {
      border-top-left-radius: 10px;
      .content {
        border-right: none;
      }
    }
    &.two {
      border-top-right-radius: 10px;
      .title {
        color: #333;
        background: var(--sub-nav-bg-color);
      }
    }
  }
  .bottom—tool-yzd {
    padding: 12px 0;
    width: 835px;
    > .title {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      text-align: center;
      line-height: 30px;
      color: #fff;
      font-weight: bold;
      background: var(--sub-nav-bg-color);
    }
    .content-yzd {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 13px;
      color: var(--new-text-info);
      background: #fff;
      .input-money {
        margin-right: 10px;
        margin-left: 10px;
        width: 71px;
        height: 26px;
        opacity: 0.7;
        border-color: var(--new-border);
        // text-align: left;
        // tex
      }
      .choice-money {
        display: inline-block;
        padding: 0 10px;
        color: var(--new-primary-color);
        line-height: 24px;
        margin: 0 2.5px;
        font-weight: bold;
        border-radius: 2px;
        cursor: pointer;
        background: var(--new-bg-table-header-main);
      }
      .add-btn {
        margin: 0 88px 0 18px;
        padding: 1px 6px;
        background: #a6a6a6;
        border-radius: 2px;
        color: #fff;
        font-size: 20px;
        cursor: pointer;
      }
      .btn-group {
        & > input {
          margin: 0 10px;
          // cursor: pointer;
          // margin-right: 14px;
          // width: 60px;
          // padding: 4px 0;
          // font-size: 12px;
          // border-radius: 2px;
          // color: #fff;
          // &:nth-child(1) {
          //   background: linear-gradient(90deg, #54b0f3, #2a92e1, #1082d8);
          // }
          // &:nth-child(2) {
          //   background: linear-gradient(90deg, #01d5c1, #00b6b8, #0096ac);
          // }
        }
      }
      & > span {
        font-size: 12px;
      }
    }
  }

  .money-tool-yzd {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .quick-choice-btn {
      margin-right: 15px;
      width: 70px;
      height: 20px;
      line-height: 20px;
      color: #fff;
      font-size: 14px;
      background: linear-gradient(180deg, #fdc32d, #d89527, #b06222);
      border-radius: 2px;
    }
    #presupposition {
      margin-right: 5px;
    }
  }

  .confirm-bet-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
  }

  .confirm-bet {
    outline: none;
    position: fixed;
    top: 50%;
    left: 50%;
    width: 516px;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-bottom: 1px solid #bad4e8;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    font-size: 13px;
    border-radius: 20px;
    overflow: hidden;
    z-index: 2000;
    h1.title {
      padding: 20px 0;
      position: relative;
      text-align: center;
      line-height: 24px;
      font-size: 24px;
      font-weight: normal;
      background: var(--new-bg-white);
      text-align: center;
      color: var(--new-text-active);
      i {
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        position: absolute;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        color: var(--new-text);
      }
    }
    .content {
      max-height: 280px;
      overflow: auto;
      padding: 0 15px;
      padding-top: 0;
      table {
        width: 100%;
      }
      .money {
        width: 55px;
        height: 22px;
        border-radius: 2px;
        padding: 0 5px;
      }
      .del-bet {
        margin: auto;
        cursor: pointer;
        width: 22px;
        height: 22px;
        text-align: center;
        line-height: 22px;
        border-radius: 50%;
        // background-color: #ff3737;
        color: #000;
        &:hover {
          color: var(--primary-active-text-color-2);
        }
        i {
          font-weight: bold;
        }
      }
      .bc {
        text-align: left;
        background: linear-gradient(to bottom, #fff, #bad4e8);
      }
      table {
        width: 100%;
        font-size: 13px;
        border: 1px solid var(--new-border);
        border-right: none;
        border-bottom: none;
        tr {
          border: 1px solid var(--new-border);
        }
        th,
        td {
          height: 30px;
          line-height: 30px;
          text-align: center;
          // &:not(:last-child) {
          border-right: 1px solid var(--new-border);
          border-bottom: 1px solid var(--new-border);
          // }
        }
        &.report-detail {
        }
        thead {
          background: var(--new-bg-table-header-main);
        }
        // th {
        //   font-weight: bold;
        //   // color: #401e1e;
        //   &.bg {
        //     background: #f3f5fc;
        //   }
        // }
        tr:not(.sum) {
          cursor: pointer;
        }
        .sum {
          // background-color: #f3f5fc;
          td {
            font-weight: bold;
            // color: #401e1e;
          }
        }
      }
    }
    .btn-group {
      margin-top: 20px;
      text-align: center;
      input[type="button"] {
        &:nth-child(1) {
          margin-right: 30px;
        }

        // width: 101px;
        // height: 34px;
        // border-radius: 2px;
        // color: #fff;
        // font-size: 16px;
        // &:nth-child(1) {
        //   background: linear-gradient(90deg, #01d5c1, #00b5b8, #0096ac);
        // }
        // &:nth-child(2) {
        //   background: linear-gradient(90deg, #54aff3, #2992e1, #1082d7);
        // }
      }
    }
  }
}
</style>
